import { basicMsg } from "../helpers/admin/msgHelper";

export const NewWebFormValidator = (data) => {
    let msg = '';
    const title_len = data.title.trim().length;
    //img
    const description_len = data.description.trim().length;
    const date_len = data.date.trim().length;
    const time_len = data.time.trim().length;
    const modality_len = data.modality.trim().length;
    const script_len = data.script.trim().length;
    const speakerName_len = data.speakerName.trim().length;
    const speakerDescription_len = data.speakerDescription.trim().length;
    //specialidades
    //speakerimg
    if (title_len > 2 && title_len <= 150) {
        if (data.image !== '') {
            if (description_len > 6) {
                if (date_len > 2 && date_len <= 20) {
                    if (time_len > 2 && time_len <= 20) {
                        if (modality_len > 2 && modality_len <= 50) {
                            if (script_len === 0 || script_len > 5 && script_len <= 200) {
                                if (speakerName_len > 5 && speakerName_len <= 60) {
                                    if (data.speakerImg !== '') {
                                        if (speakerDescription_len > 6) {
                                            if (data.specialties.length >= 1) {
                                                return true;
                                            } else msg = 'Ingrese al menos una especialidad del ponente';
                                        } else msg = 'Ingrese la descripción del ponente';
                                    } else msg = 'Ingrese imagen del ponente';
                                } else msg = 'Ingrese el nombre del ponente';
                            } else msg = 'Ingrese el script del webinar';
                        } else msg = 'Ingrese la modalidad';
                    } else msg = 'Seleccione la hora';
                } else msg = 'Seleccione fecha';
            } else msg = 'Ingrese la descripción del webinar';
        } else msg = 'Ingrese la imagen del webinar';
    } else msg = 'Ingrese titulo para el webinar';
    basicMsg(msg);
    return false;
}

export const NewOldWebFormValidator = (data) => {
    let msg = '';
    const title_len = data.title.trim().length;
    const date_len = data.date.trim().length;
    const speaker_len = data.speaker.trim().length;
    const iframe_len = data.iframe.trim().length;
    if (title_len > 2 && title_len <= 150) {
        if (date_len > 2 && date_len <= 20) {
            if (speaker_len > 4 && speaker_len < 70) {
                if (iframe_len > 10) {
                    return true
                } else msg = 'Ingrese el enlace de youtube para el old webinar';
            } else msg = 'Ingrese el nombre del ponente';
        } else msg = 'Seleccione la fecha del old webinar';
    } else msg = 'Ingrese el titulo del old webinar';
    basicMsg(msg)
    return false;
}

// https://www.youtube.com/embed/TW1H-GfM1GU?si=JKIoMo9A8ipq8dg7
// https://www.youtube.com/embed/7xxgRUyzgs0?si=5zvR7TaEZWM0-QKF
// https://www.youtube.com/embed/bfdqq_cndNg?si=m_MOa0o8AaF3QQ5g
// https://www.youtube.com/embed/LPzr5uUdrFc?si=tVE3OsLwv-RfgfEw
// https://www.youtube.com/embed/eOUtsybozjg?si=SQ4PqHlJ6-Vu1agt
